import axios from 'axios';
let base = 'https://www.carcredit.com.cn/carcredit'; //  需手动更改
//新闻在线接口
export const getSelectNewsList = params => { return axios.post(base + '/carcreditNews/selectNewsList', params).then(res => res.data) }

//新闻列表详情接口
export const getNewsById = params => { return axios.get(base + `/carcreditNews/getNewsById?newsId=${params}`).then(res => res.data) }

//商户加盟
// export const addMeachant = params => { return axios.post(base + '/carcreditMeachant/addMeachant', params).then(res => res.data) }

//省市区
export const getAllAreas = params => { return axios.post(base + `/Dictionary/getAllAreas`).then(res => res.data) }

// 商户加盟
export const addMeachant = params => { return axios.post('https://ccbs.carcredit.com.cn/appdealer/carcreditMeachant/defaultOpenPath/addMeachant', params).then(res => res.data) }





// WEBPACK FOOTER //
// ./src/api/api.js